import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import BackgroundButton from './background-button';
import { surfaceButtonStyles } from './styles';

export function SurfaceButton(props) {
  const { className, classes, color, customEndIcon, customStartIcon, children, ...other } = props;

  return (
    <BackgroundButton
      className={className}
      color={color}
      customStartIcon={customStartIcon}
      customEndIcon={customEndIcon}
      classes={classes}
      {...other}
    >
      {children}
    </BackgroundButton>
  );
}

export default withStyles(surfaceButtonStyles)(SurfaceButton);
